// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__7-lXm","headings":"SectionHeader_headings__5Sp0V","filters":"SectionHeader_filters__yuWnw"};